import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "using-web-frameworks-and-libraries"
    }}>{`Using Web Frameworks and Libraries`}</h1>
    <h2 {...{
      "id": "typescript-definitions"
    }}>{`Typescript definitions`}</h2>
    <p>{`The Add-on SDK's are a set of interfaces written in TypeScript, and a TypeScript definitions package named `}<inlineCode parentName="p">{`ccweb-add-on-sdk-types`}</inlineCode>{` is automatically included in the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` for the `}<inlineCode parentName="p">{`typescript`}</inlineCode>{` and `}<inlineCode parentName="p">{`react-typescript`}</inlineCode>{` templates. As a result, a `}<inlineCode parentName="p">{`add-on-ui-sdk.d.ts`}</inlineCode>{` file is generated in the `}<inlineCode parentName="p">{`src`}</inlineCode>{` folder that exports the `}<inlineCode parentName="p">{`AddOnUISdk`}</inlineCode>{` types, allowing you to take advantage of auto-completion and type checking capabilities. To use the type definitions, simply import them as needed in your `}<inlineCode parentName="p">{`.ts`}</inlineCode>{` file, such as:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import {
  Application,
  AuthorizationRequest,
} from "@adobe-ccwebext/ccweb-add-on-sdk-types";
`}</code></pre>
    <p>{`An example of how this works in Visual Studio Code is shown in this short clip below.`}<br /></p>
    <div style={{
      "display": "flex",
      "justifyContent": "center"
    }}>
      <iframe src="https://drive.google.com/file/d/1FzUaPZMjPD9k0ANQNibqRMiZRrSAIChg/preview" width="800" height="450" allow="autoplay"></iframe>
    </div>
    <InlineAlert slots="text" variant="info" mdxType="InlineAlert" />
    <p>{`Check out the `}<a parentName="p" {...{
        "href": "../../learn/how_to/tutorials/using-lit-typescript.md"
      }}>{`Using Lit & Typescript Guide`}</a>{` for a more detailed explanation of using TypeScript with the Add-on SDK.`}</p>
    <h2 {...{
      "id": "webpack--javascript-bundler"
    }}>{`Webpack & JavaScript bundler`}</h2>
    <p>{`When using Node libraries or other frameworks, you'll often need to use a JavaScript bundler. All of the templates the CLI provides (other than the basic `}<inlineCode parentName="p">{`javascript`}</inlineCode>{` template) are pre-configured for webpack via the `}<inlineCode parentName="p">{`--use`}</inlineCode>{` option set on the `}<inlineCode parentName="p">{`ccweb-add-on-scripts`}</inlineCode>{` commands. If you create a new add-on project based on a react or typescript based template for instance, you will see the following `}<inlineCode parentName="p">{`scripts`}</inlineCode>{` block generated in your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, and the existence of a `}<inlineCode parentName="p">{`webpack.config.js`}</inlineCode>{` in the root of your project:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"scripts": {
    "clean": "ccweb-add-on-scripts clean",
    "build": "ccweb-add-on-scripts build --use webpack",
    "start": "ccweb-add-on-scripts start --use webpack",
    "package": "ccweb-add-on-scripts package --use webpack"
},
`}</code></pre>
    <p>{`However, if you want to use any other transpiler or bundler of your choice, you can do so, provided you have the correct configurations and packages installed (similar to how these templates have `}<inlineCode parentName="p">{`webpack.config.js`}</inlineCode>{` defined, and its plugins and loaders installed). For example, if you want to use `}<inlineCode parentName="p">{`tsc`}</inlineCode>{` to transpile the `}<inlineCode parentName="p">{`.ts`}</inlineCode>{` files, you'll need to install the typescript package and add `}<inlineCode parentName="p">{`tsconfig.json`}</inlineCode>{` to your project, then configure the script commands to make the transpilation and hosting work:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"scripts": {
    "build": "ccweb-add-on-scripts build --use tsc",
    "start": "ccweb-add-on-scripts start --use tsc",
    "package": "ccweb-add-on-scripts package --use tsc"
}
`}</code></pre>
    <InlineAlert slots="text" variant="info" mdxType="InlineAlert" />
    <p>{`The `}<inlineCode parentName="p">{`src`}</inlineCode>{` folder in your project should contain all of your code and static asset files to ensure any changes you make are automatically detected by the hot module reloader, allowing you to see your updates immediately.`}</p>
    <h4 {...{
      "id": "update-webpackconfigjs-with-any-new-files-to-be-copied"
    }}>{`Update `}<inlineCode parentName="h4">{`webpack.config.js`}</inlineCode>{` with any new files to be copied`}</h4>
    <p>{`Configurations are included in the `}<inlineCode parentName="p">{`webpack.config.js`}</inlineCode>{` generated with your add-on project for both development and production bundling (assuming your project was based on any template other than the basic javascript one). You should be aware that you will need to update the `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/copy-webpack-plugin"
      }}><inlineCode parentName="a">{`CopyWebpackPlugin`}</inlineCode></a>{` block in your `}<inlineCode parentName="p">{`webpack.config.js`}</inlineCode>{` to ensure any new files are copied into the `}<inlineCode parentName="p">{`dist`}</inlineCode>{` folder at build time. For instance, if you add new image assets into your `}<inlineCode parentName="p">{`src`}</inlineCode>{` folder that your add-on is using, you would need to ensure you include the file extension in the patterns of files getting copied, or you will get a 404 indicating the images are not found. If the images were type `}<inlineCode parentName="p">{`.png`}</inlineCode>{` for instance, then you could include the additional `}<inlineCode parentName="p">{`src/*.png`}</inlineCode>{` line like below to ensure they are copied:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`new CopyWebpackPlugin({
    patterns: [
        { from: "src/*.json", to: "[name][ext]" },
        { from: "src/*.png", to: "[name][ext]" }
    ]
})
`}</code></pre>
    <h2 {...{
      "id": "react"
    }}>{`React`}</h2>
    <p>{`The CLI supports two different `}<a parentName="p" {...{
        "href": "../../getting_started/local_development/dev_tooling.md#templates"
      }}>{`react-based templates`}</a>{`, and the `}<a parentName="p" {...{
        "href": "../../learn/samples.md"
      }}>{`code samples`}</a>{` repository contains various add-ons built with React for you to use as a reference.`}</p>
    <h2 {...{
      "id": "lit-framework"
    }}>{`Lit Framework`}</h2>
    <p>{`Build fast, lightweight web components using the Lit framework. Our CLI offers `}<a parentName="p" {...{
        "href": "../../getting_started/local_development/dev_tooling.md#templates"
      }}>{`starter templates`}</a>{` to help you get started:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`swc-javascript`}</inlineCode>{`: For building with Lit and JavaScript`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`swc-typescript`}</inlineCode>{`: For building with Lit and TypeScript`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`swc-typescript-with-document-sandbox`}</inlineCode>{`: For building with Lit and TypeScript with the Document Sandbox`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`swc-javascript-with-document-sandbox`}</inlineCode>{`: For building with Lit and JavaScript with the Document Sandbox`}</li>
    </ul>
    <p>{`All templates come pre-configured with the necessary setup and dependencies.`}</p>
    <p>{`For detailed guidance on using Lit with TypeScript, you can check out our `}<a parentName="p" {...{
        "href": "../../learn/how_to/tutorials/using-lit-typescript.md"
      }}>{`Using Lit & TypeScript Guide`}</a>{`.`}</p>
    <h2 {...{
      "id": "other-javascript-and-css-libraries"
    }}>{`Other JavaScript and CSS libraries`}</h2>
    <p>{`You can enhance your add-ons with additional JavaScript and CSS libraries like jQuery or Bootstrap. Follow these steps to integrate them:`}</p>
    <ol>
      <li parentName="ol">{`Add the library's scripts and stylesheets to your project.`}</li>
      <li parentName="ol">{`Configure your bundler to process these files.`}</li>
      <li parentName="ol">{`Import the libraries where needed in your code.`}</li>
    </ol>
    <InlineAlert slots="text" variant="info" mdxType="InlineAlert" />
    <p>{`Make sure your chosen bundler is properly configured to handle any additional libraries you include.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      